// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"267":"55c29977","300":"95ccaa94","472":"daeb2d99","668":"d7477707"}[chunkId] + ".chunk.css";
};